import { MercadoPagoAuthModal } from '@/components/mercadopago/MercadoPagoAuthModal';
import { useMercadoPagoAuth } from '@/hooks/useMercadoPagoAuth';
import { CreditCardIcon } from 'lucide-react';
import type React from 'react';

export const MercadoPagoCard: React.FC = () => {
  const {
    isModalOpen,
    setIsModalOpen,
    hasMercadoPagoAuth,
    handleAuthorizeMercadoPago,
  } = useMercadoPagoAuth();

  return (
    <section className="rounded-[14px] border border-gc-line bg-white p-4">
      <div className="mb-2 flex items-center gap-2">
        <CreditCardIcon className="h-5 w-5 text-gc-blue" />
        <h2 className="text-[16px] font-bold text-gc-ink">MercadoPago</h2>
      </div>
      {hasMercadoPagoAuth ? (
        <p className="text-[13.5px] text-gc-muted">MercadoPago conectado.</p>
      ) : (
        <>
          <p className="mb-3 text-[13.5px] text-gc-muted">
            Conectá MercadoPago para poder cobrar con tarjeta.
          </p>
          <button
            type="button"
            onClick={handleAuthorizeMercadoPago}
            className="rounded-lg bg-gc-blue px-4 py-2 text-[13.5px] font-medium text-white transition-colors hover:opacity-90"
          >
            Conectar MercadoPago
          </button>
        </>
      )}
      <MercadoPagoAuthModal
        isOpen={isModalOpen}
        onOpenChange={setIsModalOpen}
        onAuthorizeMercadoPago={handleAuthorizeMercadoPago}
      />
    </section>
  );
};
